import React, { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import ShowButton from '../../../../shared-components/ShowMore/ShowButton';
import trns from './trns';
import ShowMore from '../../../../shared-components/ShowMore/ShowMore';

interface Props {
  text: string | JSX.Element;
}
const Comment: FC<Props> = ({ text }) => {
  const [isBlur, setBlur] = useState(true);
  const handlerShowLes = (value) => {
    setBlur(!value);
  };
  return (
    <ShowMore
      showLines={4}
      showMore={
        <ShowButton
          isShowIcon={true}
          isBlur={isBlur}
          iconStyle={'border-none rounded-none'}
          title={<FormattedMessage {...trns.showMoreTitle} />}
          active={true}
        />
      }
      showLess={
        <ShowButton
          isShowIcon={true}
          isBlur={isBlur}
          iconStyle="border-none rounded-none"
          title={<FormattedMessage {...trns.showLessTitle} />}
          active={false}
        />
      }
      handlerShowLessClick={handlerShowLes}
      isExtendedFunction={true}
      width={330}
      customClassName="min-h-[100px]"
    >
      <div className="text-shuttleGray fs-caption-reg">{text}</div>
    </ShowMore>
  );
};

export default Comment;
